export { SEO, type SEOProps } from "./SEO";
